import { createSlice } from "@reduxjs/toolkit";
import { getAllUsers, handleBlockUser } from "./action";
const initialState = {
  users: {
    success: null,
    loading: false,
    list: [],

  },
  listData: {
    list: null,
    count: 0,
    isBlock: false,
    loading: false
  }
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(getAllUsers.pending, (state) => {
      state.listData.loading = true;
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.listData.loading = false;

      if (action.payload?.success) {
        state.listData.list =
          action.payload?.data?.users?.length > 0 ? action.payload?.data?.users : [];
        state.listData.count = action.payload?.data?.pagination?.total || 0;
      } else {
        state.listData.list = [];
        state.listData.count = 0;
      }
    });


    builder.addCase(getAllUsers.rejected, (state) => {
      state.listData.loading = false;
    });
    builder.addCase(handleBlockUser.pending, (state) => {
      state.users.loading = true;

    });
    builder.addCase(handleBlockUser.fulfilled, (state, action) => {
      state.users.loading = false;

      const { userId, action: blockAction } = action.payload;

      const newStatus = blockAction === "block" ? "BLOCKED" : "ACTIVE";

      // update user inside list
      const user = state.listData.list?.find(
        (u) => u.id === userId
      );

      if (user) {
        user.status = newStatus;
      }
    });

    builder.addCase(handleBlockUser.rejected, (state) => {
      state.users.loading = false;

    });
  },
});


export default userSlice.reducer;
